import { resolveBuildRunNumber } from '@/features/builds/utils/buildRunNumber';
import {
  buildStageDetailPath,
  buildStageExecutionDetailPath,
  buildSyntheticStageId,
} from '@/features/pipelines/utils/stagePaths';
import type { SummaryTooltipItem } from '@/ui/composites/table/tableUtils';
import type { BuildDto, PipelineListItemDto, PipelineStageListItemDto } from '@flowqa/shared';

export const mapStageExecutionSummaryItems = (
  row: PipelineStageListItemDto,
): SummaryTooltipItem[] =>
  (row.executionSummaries ?? []).map((execution) => {
    const runNumber = resolveBuildRunNumber(execution.buildKey ?? null);

    return {
      key: execution.id,
      detailLabel: row.stageName,
      executionLabel: runNumber === null ? null : `#${runNumber}`,
      href: buildStageDetailPath(row.id),
      executionHref: buildStageExecutionDetailPath({
        stageExecutionId: execution.id,
        pipelineId: row.pipelineId,
        stageName: row.stageName,
      }),
      runNumber,
      status: execution.status,
      timestamp: execution.timestamp,
    };
  });

export const mapPipelineStageSummaryItems = (row: PipelineListItemDto): SummaryTooltipItem[] => {
  const runNumber = resolveBuildRunNumber(row.latestRun?.buildKey ?? null);

  return (row.stageSummaries ?? []).map((stage) => ({
    key: stage.id,
    detailLabel: stage.stageName,
    executionLabel: runNumber === null ? null : `#${runNumber}`,
    href: buildStageDetailPath(buildSyntheticStageId(row.id, stage.stageName)),
    executionHref: buildStageExecutionDetailPath({
      stageExecutionId: stage.id,
      pipelineId: row.id,
      stageName: stage.stageName,
    }),
    runNumber,
    status: stage.status,
    timestamp: stage.timestamp,
  }));
};

export const mapBuildStageSummaryItems = (row: BuildDto): SummaryTooltipItem[] => {
  const runNumber = resolveBuildRunNumber(row.buildKey ?? null);

  return (row.stageSummaries ?? []).map((stage) => ({
    key: stage.id,
    detailLabel: stage.stageName,
    executionLabel: runNumber === null ? null : `#${runNumber}`,
    href: buildStageDetailPath(buildSyntheticStageId(row.pipelineId ?? null, stage.stageName)),
    executionHref: buildStageExecutionDetailPath({
      stageExecutionId: stage.id,
      pipelineId: row.pipelineId ?? null,
      stageName: stage.stageName,
    }),
    runNumber,
    status: stage.status,
    timestamp: stage.timestamp,
  }));
};
